<div class="contacts-filter-container" [formGroup]="form">
    <div class="contacts-filter-col col-2">
        <p-dropdown
            (onShow)="onFilterContactTypeShow()"
            (onHide)="onFilterContactTypeHide()"
            [options]="contacts"
            placeholder="Тип контакт"
            (onChange)="onContactTypeChange($event)"
            formControlName="type"
            [dropdownIcon]="updateDropdownIcon(filtersOpenState.contactType)"
        >
            <ng-template let-contactType pTemplate="item">
                <div class="dropdown-option">
                    <span>{{ contactType.name }}</span>
                </div>
            </ng-template>

            <ng-template let-contactType pTemplate="selectedItem">
                <div class="dropdown-option">
                    <span>{{ contactType?.name }}</span>
                </div>
            </ng-template>
        </p-dropdown>
    </div>

    <!--    Individual-->
    @if (form.get('isIndividual')?.value === true) {
        <div class="contacts-filter-col col-2">
            <app-input
                label="Име"
                class="custom-placeholder"
                [dynamicPlaceholder]="true"
                placeholder="Име"
                styleClass="filter-input-btn custom-filter-input"
                formControlName="firstName"
            />
        </div>
    }
    @if (form.get('isIndividual')?.value === true) {
        <div class="contacts-filter-col col-2">
            <app-input
                label="Фамилия"
                class="custom-placeholder"
                [dynamicPlaceholder]="true"
                placeholder="Фамилия"
                styleClass="filter-input-btn custom-filter-input"
                formControlName="lastName"
            />
        </div>
    }

    <!--    Legal entity -->
    @if (form.get('isIndividual')?.value === false) {
        <div class="contacts-filter-col col-2">
            <app-input
                label="Име на компания"
                class="custom-placeholder"
                [dynamicPlaceholder]="true"
                placeholder="Име на компания"
                styleClass="filter-input-btn custom-filter-input"
                formControlName="companyName"
            />
        </div>
    }

    @if (form.get('isIndividual')?.value === false) {
        <div class="contacts-filter-col col-2">
            <app-input
                label="ЕИК"
                class="custom-placeholder"
                [dynamicPlaceholder]="true"
                placeholder="ЕИК"
                styleClass="filter-input-btn custom-filter-input"
                formControlName="companyEic"
            />
        </div>
    }

    <div class="contacts-filter-col col-2">
        <app-input
            label="Телефон"
            class="custom-placeholder"
            [dynamicPlaceholder]="true"
            placeholder="Телефон"
            styleClass="filter-input-btn custom-filter-input"
            formControlName="phone"
        />
    </div>

    <div class="contacts-filter-col col-2">
        <app-input
            label="Email"
            class="custom-placeholder"
            [dynamicPlaceholder]="true"
            placeholder="Email"
            styleClass="filter-input-btn custom-filter-input"
            formControlName="email"
        />
    </div>

    <div class="contacts-filter-col col-2">
        <p-dropdown
            (onShow)="onFilterOwnershipShow()"
            (onHide)="onFilterOwnershipHide()"
            [options]="ownerships"
            optionLabel="name"
            [dropdownIcon]="updateDropdownIcon(filtersOpenState.ownership)"
            formControlName="ownership"
        >
            <ng-template let-ownership pTemplate="item">
                <div class="dropdown-option">
                    <app-svg-icon [icon]="'dot-icon'" size="small" [color]="ownership.color" />
                    <span>{{ ownership.name }}</span>
                </div>
            </ng-template>
            <ng-template let-ownership pTemplate="selectedItem">
                <div class="dropdown-option">
                    <app-svg-icon [icon]="'dot-icon'" size="small" [color]="ownership.color" />
                    <span>{{ ownership?.name }}</span>
                </div>
            </ng-template>
        </p-dropdown>
    </div>

    <!--    Source-->
    <div class="contacts-filter-col" [ngClass]="form.get('hasSource')?.value ? 'col-1' : 'col-3'">
        <p-dropdown
            (onShow)="onFilterSourceShow()"
            (onHide)="onFilterSourceHide()"
            [options]="sources"
            [showClear]="true"
            formControlName="source"
            placeholder="Източници"
            [group]="true"
            (onChange)="onSourceChange($event)"
            [dropdownIcon]="updateDropdownIcon(filtersOpenState.source)"
        >
            <ng-template let-group pTemplate="group">
                <div class="flex align-items-center">
                    <span>{{ group.label }}</span>
                </div>
            </ng-template>
        </p-dropdown>
    </div>

    <!--    Source-detail-->
    @if (form.get('hasSource')?.value === true) {
        <div class="contacts-filter-col col-2">
            <p-dropdown
                (onShow)="onFilterSourceDetailShow()"
                (onHide)="onFilterSourceDetailHide()"
                [options]="sourceDetail"
                formControlName="sourceDetail"
                optionLabel="name"
                placeholder="Източник-детайл"
                [dropdownIcon]="updateDropdownIcon(filtersOpenState.hasSource)"
            >
                <ng-template let-item pTemplate="item">
                    <div class="dropdown-option">
                        <span>{{ item.name }}</span>
                    </div>
                </ng-template>
                <ng-template let-item pTemplate="selectedItem">
                    <div class="dropdown-option">
                        <span>{{ item?.name }}</span>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
    }

    <!--Date-->
    <div class="contacts-filter-col col-2">
        <app-datepicker [placeholder]="'CreatedOn' | localize" formControlName="createdOn" [customClass]="'created-0n'"></app-datepicker>
    </div>

    <div class="contacts-filter-col col-2 filterResultsBtn-wrapper">
        <app-button
            [text]="'ShowResults' | localize"
            class="filterResultsBtn"
            [fullHeight]="true"
            [fullWidth]="true"
            (click)="onSubmit()"
        ></app-button>
    </div>

    <!--Advanced filters------------------------------->
    <div class="contacts-filter-col advanced-filters">
        <div class="flex-alignment">
            <p-button
                styleClass="filter-input-btn"
                (click)="toggleAdvancedFilters()"
                [label]="'AdvancedFilters' | localize"
                class="advanced-toggle"
                [icon]="updateAdvancedFiltersDropdownIcon(filtersOpenState.advancedFilters)"
            />
            <span class="filter-counter">{{ loadedResultsCount }}</span>
        </div>
        <div class="flex-alignment clear-all" (click)="clearAll()">
            Изчисти филтрите
            <i class="pi pi-times cursor-pointer ng-star-inserted"></i>
        </div>
    </div>
    @if (filtersOpenState.advancedFilters) {
        <div class="advanced-filters-container">
            <app-advanced-filters
                [isIndividual]="form.get('isIndividual')?.value"
                (trueValuesChange)="updateLoadedResultsCount($event)"
                (allValuesCleared)="handleAllValuesCleared()"
            ></app-advanced-filters>
        </div>
    }
</div>
